import React from "react";
import PropTypes from 'prop-types';
import SelectDataTable from '../form/SelectDataTable';
import ProductOfferingColumn from "../../component/dataTable/columns/ProductOfferingColumn";
import Service from "../../service/Service";
import { Constant, TENANT_ID } from "../../utils/Constants";

export default class ProductOfferingGroup extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            value: this.props.value,
            validate: this.props.validate,
            dataTable: this.props.dataTable,
            label: this.props.label,
            disabled: this.props.disabled,
            productType: this.props.productType,
        };
        this.service = new Service("productOffering");
    }

    componentWillReceiveProps = (nextProps) => {
        this.setState({
            validate: nextProps.validate,
            value: nextProps.value,
            dataTable: nextProps.dataTable,
            label: nextProps.label,
            productType: nextProps.productType,
            disabled: nextProps.disabled
        });
    }

    render() {
        let validate = this.state.validate;
        if (!validate) {
            validate = {
                required: {
                    value: true,
                    errorMessage: "Bu alanın doldurulması zorunludur."
                }
            };
        }

        let dataTable = this.state.dataTable;
        let URL =  "productOffering/findAll" + (Constant.TENANT == TENANT_ID.GSB ? ("/"+this.state.productType) : "");
        if (!dataTable) {
            dataTable = {
                dataURL :URL,
                fields: ProductOfferingColumn.fields
            };
        }

        let label = this.state.label;
        if (!label) {
            label = "Teklif"
        }
        return (
            <SelectDataTable
                value={this.state.value}
                validate={validate}
                dataTable={dataTable}
                disabled={this.state.disabled}
                name="productOffering"
                translateKey="defaultHsmProductOffering"
                label={label}
                dialogHeader="Teklif Listesi"
                onDataSelect={this.props.onDataSelect}
                autoRefrestData={this.props.autoRefrestData ? this.props.autoRefrestData : false}
            />
        );
    }
}
ProductOfferingGroup.propTypes = {
    value: PropTypes.string,
    validate: PropTypes.object,
    dataTable: PropTypes.object
}